import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ConfirmDialogData } from 'src/app/models/common';
import { Column } from 'src/app/models/doctorregistration';
import { CommonService } from 'src/app/services/common.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-table-data',
    templateUrl: './table-data.component.html',
    styleUrls: ['./table-data.component.css']
})
@TraceClassDecorator()
export class TableDataComponent implements OnInit {
    constructor(
        private readonly utilitiesService: UtilitiesService,
        private readonly commonService: CommonService
    ) {}

    @Input('columns')
    columns: Column[] = [];

    @Input('data')
    data: any[] = [];

    @Output('onUpdate')
    onUpdate: EventEmitter<any[]> = new EventEmitter<any[]>();

    id: number = -1;
    is_new: boolean = false;
    temp_edit_data = {};
    temp_new_data = {};
    // delete_confirm_dialog: boolean = false;
    delete_id: number = null;
    deleteDataDialog: ConfirmDialogData =
        this.commonService.confirmDialog_init();

    deleteDialogAction(event) {
        if (Boolean(event)) {
            this.confirm_delete();
        } else {
            this.closeDialog();
        }
    }

    reset_init() {
        this.id = -1;
        this.is_new = false;
        this.temp_edit_data = {};
        this.temp_new_data = {};
        // this.delete_confirm_dialog = false;
        this.deleteDataDialog.show = false;
        this.delete_id = null;
        this.temp_edit_data_init();
        this.create_new_data_init();
    }

    closeDialog() {
        // this.delete_confirm_dialog = false;
        this.deleteDataDialog.show = false;
    }

    add() {
        this.create_new_data_init();
        this.data.push(this.temp_new_data);
        this.is_new = true;
        this.id = this.data.length;
    }

    edit(row) {
        // this.temp_data_init
        Object.keys(this.temp_edit_data).map(
            (ele) => (this.temp_edit_data[ele] = row[ele])
        );
        this.id = row[this.getKeyIDField()];
    }

    cancel(row) {
        if (!this.is_new) {
            Object.keys(this.temp_edit_data).map(
                (ele) => (row[ele] = this.temp_edit_data[ele])
            );
        } else {
            this.data.pop();
        }
        this.reset_init();
    }

    save(row) {
        this.reset_init();
        this.emitData();
    }

    remove(row) {
        this.delete_id = Number(row[this.getKeyIDField()]) - 1;
        // this.delete_confirm_dialog = true;
        this.deleteDataDialog.show = true;
        // this.data.splice(Number(row.id), 1);
    }

    confirm_delete() {
        this.data.splice(this.delete_id, 1);
        this.reinit_key_id();
        this.reset_init();
        this.emitData();
    }

    canSave(row) {
        let a: Column[] = this.columns.filter(
            (ele) => ele.is_edit && ele.is_display
        );
        let b: Column[] = a.filter((ele) => row[ele.field].length > 0);
        return !(a.length == b.length);
    }

    emitData() {
        this.onUpdate.emit(this.data);
    }

    reinit_key_id() {
        let i = 1;
        this.data.map((ele) => (ele[this.getKeyIDField()] = i++));
    }

    create_data_key_init(ele: Column) {
        if (ele['is_key']) {
            if (ele['data_type'] === 'string') {
                this.temp_new_data[ele['field']] = (
                    this.data.length + 1
                ).toString();
            } else if (ele['data_type'] === 'number') {
                this.temp_new_data[ele['field']] = this.data.length + 1;
            }
        } else {
            if (ele['data_type'] == 'string') {
                this.temp_new_data[ele['field']] = '';
            }
            if (ele['data_type'] == 'number') {
                this.temp_new_data[ele['field']] = -1;
            }
        }
    }

    create_new_data_init() {
        // let obj = { data: {} };
        // this.columns.map((ele) => this.create_data_key_init(ele, obj.data));
        // // this.getAllKeys(this.columns).map((ele))
        // return obj.data;

        this.getAllDataFields().map((element) =>
            this.create_data_key_init(element)
        );
    }

    temp_data_key_init(element: string) {
        this.temp_edit_data[element] = null;
    }

    getIsNew(): boolean {
        return this.is_new;
    }

    temp_edit_data_init() {
        this.getAllKeys(this.getAllDataFields()).map((element) =>
            this.temp_data_key_init(element)
        );
    }

    getKeysAndDataTypes() {
        return this.columns.map((element) => [
            element['field'],
            element['data_type']
        ]);
    }

    getAllKeys(data: Column[]) {
        return data.map((element) => element['field']);
    }

    getAllDataFields() {
        return this.columns.filter((element) => element['is_data_field']);
    }

    getKeyIDField() {
        return this.columns.filter((element) => element.is_key == true)[0][
            'field'
        ];
    }
    getIsEdit(field_name: string) {
        return this.columns.filter(
            (element) => element.field === field_name
        )[0]['is_edit'];
    }

    getIsKey(field_name: string) {
        return this.columns.filter(
            (element) => element.field === field_name
        )[0]['is_key'];
    }

    getIsDisplay(field_name: string) {
        return this.columns.filter(
            (element) => element.field === field_name
        )[0]['is_display'];
    }

    isCurrentEdit(row) {
        return Number(row[this.getKeyIDField()]) == Number(this.id);
    }

    isDropdown(column: Column) {
        return column['input_type'] === 'dropdown';
    }

    isText(column: Column) {
        return column['input_type'] === 'text';
    }

    isTextArea(column: Column) {
        return column['input_type'] === 'textarea';
    }

    isButton(column: Column) {
        return column['input_type'] === 'button';
    }

    isEditColumn(field_name: string) {
        return field_name === 'edit';
    }

    autoresize_textarea(event) {
        this.utilitiesService.autoresize_textarea(event, 'autoresizer');
    }

    ngOnInit(): void {
        this.deleteDataDialog = {
            show: false,
            data: {
                header: 'Confirm Delete',
                body_text: 'Are sure you want to delete the current data?',
                cancel_btn_label: 'Cancel',
                cancel_btn_class: 'btn btn-secondary',
                cancel_btn_display: true,
                confirm_btn_label: 'Delete',
                confirm_btn_class: 'btn btn-primary',
                confirm_btn_display: true
            }
        };
        this.temp_edit_data_init();
        // this.create_new_data_init();
    }
}
